import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  Typography,
  Button
} from '@mui/material';

const FrequentlyBoughtTogether = ({ products = [], onAddToCart }) => {
  // ✅ Set all product IDs as selected initially
  const [selectedIds, setSelectedIds] = useState(() =>
    products.map((p) => p.id)
  );

  const toggleProduct = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const selectedProducts = products.filter((p) => selectedIds.includes(p.id));

  const totalPrice = selectedProducts.reduce((sum, p) => {
    const price = parseFloat(p.prices[0]?.final_price || 0);
    return sum + price;
  }, 0);

  return (
    <Box>
      <Typography pb={2} variant="h5">
        Frequently Bought Together
      </Typography>

      <Box display="flex" flexWrap="wrap" alignItems="center">
        {products.map((product, index) => (
          <Box key={product.id} display="flex" alignItems="center">
            <Card sx={{ width: {xs:130, lg: 200}, position: 'relative', mb: 2 }}>
              <Checkbox
                checked={selectedIds.includes(product.id)}
                onChange={() => toggleProduct(product.id)}
                sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1 }}
              />
              <CardMedia
                component="img"
                height="140"
                image={product.images[0]}
                alt={product.product_name}
              />
              <CardContent>
                <Typography variant="subtitle1" noWrap>
                  {product.product_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ₹{parseFloat(product.prices[0]?.final_price || 0).toFixed(2)}
                </Typography>
              </CardContent>
            </Card>

            {index < products.length - 1 && (
              <Typography
                variant="h4"
                sx={{ mx: 1, mb: 2 }}
                color="text.secondary"
              >
                +
              </Typography>
            )}
          </Box>
        ))}
      </Box>

      <Box sx={{display:'flex', columnGap:'10px', alignItems:'center'}} mt={2}>
        <Typography sx={{fontWeight:'600', mb:0}} variant="subtitle1" gutterBottom>
          Total: ₹{totalPrice.toFixed(2)}
        </Typography>
        <Button
          variant="contained"
          color="success"
          onClick={() => onAddToCart(selectedProducts)}
          disabled={selectedProducts.length === 0}
          sx={{
            textTransform:'capitalize'
          }}
        >
          Add {selectedProducts.length} to cart
        </Button>
      </Box>
    </Box>
  );
};

export default FrequentlyBoughtTogether;
